/*
 * The colour world of each project on the hero's device stage. The flowing background and the whole
 * hero follow the site that is on show: a dark site gives a deep, vivid background and light text;
 * a light site gives an airy background and dark text. Four colours per project, darkest to brightest,
 * taken from the site itself.
 */
export type HeroMode = 'dark' | 'light';

export interface Look {
    mode: HeroMode;
    colors: [string, string, string, string];
}

export const LOOKS: Record<string, Look> = {
    // Dark, purple and teal gradient accents
    'acom-detailing': { mode: 'dark', colors: ['#0a0c17', '#251a63', '#7b46ec', '#45ffe9'] },
    // Pastel pink and peach
    'roos-heylen': { mode: 'light', colors: ['#ffdcd8', '#ffb0c0', '#ff9470', '#a58aff'] },
    // Near black with a red glow
    'nerv-models': { mode: 'dark', colors: ['#07070a', '#1c1d27', '#d2382b', '#ff8a4a'] },
    // Ice blue with soft gold
    'bosmans-studentenkamers': { mode: 'light', colors: ['#cfdcff', '#9db9ff', '#4f7dff', '#ffc233'] },
    // Deep navy with emerald
    studiebooster: { mode: 'dark', colors: ['#0a0f3b', '#1b2182', '#1fae85', '#62efb0'] },
    // Fresh greens with warm sun
    'tuinen-tuur-geerits': { mode: 'light', colors: ['#d5f0cb', '#a9e29a', '#4fb96c', '#ffd75e'] },
};

export const DEFAULT_LOOK: Look = LOOKS['acom-detailing'];
